import React, { useContext, useEffect, useState, useMemo } from "react";
import {
  Card,
  Col,
  Row,
  Button,
  ListGroup,
  ListGroupItem,
} from "react-bootstrap";
import { getCDNImage } from "../globals";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faCalendarAlt,
  faCheckCircle,
} from "@fortawesome/free-solid-svg-icons";
import { invertDate, formatDate } from "../functions";
import { HotelContext } from "../context/hotel";
import { CheckInContext } from "../context/checkin";
import { NavLink, useLocation } from "react-router-dom";
import { T } from "react-translator-component";
import Screen from "../components/Screen";
import { i18nValue, currencyFormat } from "../functions";
import { UserContext } from "../context/user";
import { Building } from "../components/Icons";
import Reservation from "../components/Reservation";
import { checkOut } from "../actions/roomOccupationActions";
import { useNavigate } from "react-router";
import { format } from "date-fns";
import PayButton from "../components/PayButton"
import useStayActions from "../hooks/useStayActions";
import CheckinMessagesCard from "../screens/Status/CheckinMessagesCard";
import { isHostzArosa, isHostzBecozy, isHostzBetaHouse, isHostzBlackSummit, isHostzCozy, isHostzMyde, isHostzSwissstay, isOffgrid, isSimplex } from "../components/CheckIn/hotelConditions";

const Stay = (props) => {
  const navigate = useNavigate();
  const { pathname } = useLocation();
  const {
    data: { id: hotelId, code: hotelCode },
    getUrlPath,
    sectionsByCode,
    currency
  } = useContext(HotelContext);
  const { data: checkIn } = useContext(CheckInContext);
  const {
    getNotificationObject,
    notifyMe,
    RoomOccupation,
    refreshBalanceAndInvoices,
    language,
  } = useContext(UserContext);


  useEffect(() => {
    refreshBalanceAndInvoices();
  }, []);

  const showBalance = useMemo(() => {
    return RoomOccupation?.showBalance ?? false;
  }, [RoomOccupation?.showBalance]);

  const showCheckoutButton = useMemo(() => {
    return false // todo: oculto para todos hasta corregir el problema
    // return (hotelId !== "44dc5e46-b6ca-43c9-8ec7-e4a4b5ebb66b" && !isSimplex(hotelId)) //KALMSTAY
  }, [hotelId]);

  const balance = useMemo(() => {
    if (!RoomOccupation?.balance) return false;
    return RoomOccupation.balance
  }, [RoomOccupation?.balance]);


  const invoices = useMemo(() => {
    if (!RoomOccupation?.invoices) return null;
    return RoomOccupation.invoices;
  }, [RoomOccupation?.invoices]);

  return (
    <Screen
      section="stay"
      title={i18nValue(sectionsByCode["stay"], "title", language) || "Stay"}
      description={i18nValue(sectionsByCode["stay"], "desc", language)}
      headerContent={
        (checkIn.status === "in_stay" || checkIn.status === "done") &&
        checkIn.reservation && (
          <div className="reservation-header" style={{ borderBottom: "1px solid rgba(0, 0, 0, 0.125)" }}>
            <Reservation
              border={false}
              showPrice={false}
              showRowInfo={!isHostzSwissstay(hotelId)} />
            {(!isOffgrid(hotelId) && !isHostzBecozy(hotelId) && !isHostzBetaHouse(hotelId) && !isHostzBlackSummit(hotelId) && !isHostzMyde(hotelId) && !isHostzArosa(hotelId) && !isHostzCozy(hotelId) && !isHostzSwissstay(hotelId)) && (
              <CheckinMessagesCard hotelCode={hotelCode} pathname={pathname} data={checkIn} />
            )}

          </div>
        )
      }
    >
      <Row className="mt-2">
        {/* <Col xs={6}>
          <Card border="default" className="mt-2 text-center" style={{ minHeight: 85 }}>
            <Card.Body className="py-2 px-3">
              <small className="d-block mb-2" style={{ fontSize: '11px', textTransform: 'uppercase', color: '#AAA' }}>Notifications</small>
              {showRequestPermission === 'accepted' && <span className="text-success general-text-sm text-uppercase"><FontAwesomeIcon icon={faCheckCircle} style={{ fontSize: 15, color: '#28a745', marginRight: 5 }} />Activadas</span>}
              {showRequestPermission === 'fix' && <span className="text-danger general-text-sm text-uppercase"><FontAwesomeIcon icon={faCheckCircle} style={{ fontSize: 15, color: '#dc3545', marginRight: 5 }} />Bloqueadas</span>}
              {showRequestPermission && showRequestPermission === 'accept' && <div className="content text-center mt-1 pt-2" style={{ borderTop: '1px solid #EEE' }}>
                <p><b>Importante!</b> Para un correcto funcionamiento le pedimos que active las notificaciones.</p>
                <div className="mt-2 mb-2">
                    <Button 
                      size={'lg'}
                      variant={'primary'} 
                      type={'button'}
                      className="text-uppercase"
                      onClick={() => notifyMe(result => {
                        console.log('notif result', result);
                        setShowRequestPermission(result === 'granted' ? 'accepted' : 'fix')
                      })}>
                        Activar
                    </Button>
                </div>
              </div>}
            </Card.Body>
          </Card>
        </Col> */}
        {/* {smartLockPinCode && <Col xs={6}>
          <Card border="default" className="mt-2 text-center">
            <Card.Body className="py-2 px-3">
              <small className="d-block mb-2" style={{ fontSize: '11px', textTransform: 'uppercase', color: '#AAA' }}>Smart Lock</small>
              <span className="text-muted">PIN:</span> <b>{smartLockPinCode}</b>
            </Card.Body>
          </Card>
        </Col>} */}
        {/* <Col xs={6}>
          <Card border="default" className="mt-2 text-center" style={{ minHeight: 85 }}>
            <Card.Body className="py-2 px-3">
              <small className="d-block mb-2" style={{ fontSize: '11px', textTransform: 'uppercase', color: '#AAA' }}>Devices</small>
              <NavLink className="btn w-100 btn-primary text-white font-size-sm" style={{ color: 'black' }} to={{ pathname: getUrlPath('/add-device')}}>{T('account.add-device')}</NavLink>
            </Card.Body>
          </Card>
        </Col> */}

        {showBalance && balance && (
          <Col xs={12}>
            <ListGroup className="list-group-flush shadow mb-3 font-size-sm mt-3">
              <ListGroupItem key={`total`} className="bg-light">
                <span
                  className="font-size-sm float-right"
                  style={{
                    lineHeight: "30px",
                    fontWeight: "bold",
                    fontSize: "1rem",
                  }}
                >
                  {currencyFormat(balance.total, balance.currency)}
                </span>
                <p
                  className="mb-0"
                  style={{
                    lineHeight: "30px",
                    fontWeight: "bold",
                    fontSize: "1rem",
                  }}
                >
                  {T("general.balance")}
                </p>
              </ListGroupItem>
              <ListGroupItem key={`charges`}>
                {console.log("balance", balance)}
                <span className="font-size-sm float-right detail-price">
                  {currencyFormat(balance.charges?.total * -1, balance.currency)}
                </span>
                <p className="font-size-sm mb-0 detail-title">
                  {T("account.charges")}
                </p>
              </ListGroupItem>
              <ListGroupItem key={`payments`}>
                <span className="font-size-sm float-right detail-price">
                  {currencyFormat(balance.payments?.total)}
                </span>
                <p className="font-size-sm mb-0 detail-title">
                  {T("account.payments")}
                </p>
              </ListGroupItem>
              <ListGroupItem key={`actions`} className="bg-light text-center m-2">
                <Row>
                  <Col className="p-2">
                    <Button
                      size={"lg"}
                      variant={"primary"}
                      type={"button"}
                      className="text-uppercase w-100 btn-lg"
                      onClick={() => {
                        navigate(`/${hotelCode}/account`, {
                          state: { from: pathname },
                        });
                      }}
                    >
                      {T("general.detail")}
                    </Button>
                  </Col>
                  <PayButton balance={balance} />
                  {checkIn.status === "in_stay" && (
                    <Col className="p-2">
                      {showCheckoutButton && <Button
                        size={"lg"}
                        variant={"primary"}
                        type={"button"}
                        className="text-uppercase w-100 btn-lg"
                        onClick={() => {
                          navigate(`/${hotelCode}/checkout`, {
                            state: { from: pathname },
                          });
                        }}
                      >
                        {T("general.checkout")}
                      </Button>}
                    </Col>
                  )}
                </Row>
              </ListGroupItem>



            </ListGroup>
            {/* <Card border="default" className="mt-2 text-center">
            <Card.Body className="py-2 px-3">
              <small className="d-block mb-2" style={{ fontSize: '11px', textTransform: 'uppercase', color: '#AAA' }}>Balance</small>
              <Row>
                <Col xs={4}>
                  <small className="d-block text-muted mb-2">Cargos</small>
                  <span className="font-size-sm">(714 EUR)</span>
                </Col>
                <Col xs={4}>
                  <small className="d-block text-muted mb-2">Pagos</small>
                  <span className="font-size-sm">620 EUR</span>
                </Col>
                <Col xs={4}>
                  <small className="d-block text-muted mb-2">Total</small>
                  <b>(94 EUR)</b>
                </Col>
              </Row>
              <Row>
                <NavLink className="btn w-100 btn-primary text-white font-size-sm mx-2 mt-2 mb-1" style={{ color: 'black' }} to={{ pathname: getUrlPath('/account')}}>Ver Detalle</NavLink>
              </Row>
            </Card.Body>
          </Card> */}

            {invoices && (
              <ListGroup className="list-group-flush shadow">
                <ListGroupItem key={`invoices`} className="bg-light">
                  <p
                    className="mb-0"
                    style={{
                      lineHeight: "30px",
                      fontWeight: "bold",
                      fontSize: "1rem",
                    }}
                  >
                    {T("account.invoices")}
                  </p>
                </ListGroupItem>
                {invoices.map((row, idx) => {
                  return (
                    <ListGroupItem key={`invoice-${idx}`}>
                      <span className="general-data float-right detail-price text-right">
                        {row.subTotal.amount} {row.subTotal.currency}
                        <br />
                        {row.outstandingPayment && (
                          <small className="text-danger">
                            -{row.outstandingPayment.amount}{" "}
                            {row.outstandingPayment.currency}
                          </small>
                        )}
                        {row.file && (
                          <div>
                            <a href={row.file} target="apaleoInvoice">
                              {T("account.download")}
                            </a>
                          </div>
                        )}
                      </span>
                      <p className="general-text-bold mb-0 detail-title">
                        <small>
                          {format(
                            new Date(row.created),
                            T("general.dateformat")
                          )}{" "}
                          - {format(new Date(row.created), "hh:mm")}
                        </small>
                        <br />
                        {row.number}
                        <br />
                        {row.guestName}
                        <br />
                      </p>
                    </ListGroupItem>
                  );
                })}
              </ListGroup>
            )}
          </Col>
        )}

        {!showBalance && checkIn.status === "in_stay" && balance &&
          <Col xs={12} className="mt-2">
            {showCheckoutButton && <Button
              size={"lg"}
              variant={"primary"}
              type={"button"}
              className="text-uppercase w-100"
              onClick={() => {
                navigate(`/${hotelCode}/checkout`, {
                  state: { from: pathname },
                });
              }}
            >
              {T("general.checkout")}
            </Button>}

          </Col>}

      </Row>
    </Screen>
  );
};

export default Stay;
